export default __webpack_public_path__ + "static/media/status.39189b72.svg";